module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_isObject.js
 ** module id = 694
 ** module chunks = 0
 **/